// Module
var code = "<blockquote class=\"theme-content-blockquote kov-template-text__blockquote\"> <span compile=\"::ctrl.sItem.$$html\"></span> <span ng-if=\"ctrl.sItem.creators[0]\" class=\"kov-template-text__blockquote-credit\">{{ctrl.sItem.creators[0]}}</span> </blockquote> ";
// Exports
module.exports = code;